const isMoneyEnabled = (orgId) => {
    switch (orgId) {
        case 8: // Healthy Relationships
            return false;
        case 14: // BCH
            return false;
        case 90: // Apex Interview One
            return false;
        case 94: // BCH Leaders
            return false;
        case 102: // BCH  Global
            return false;
        case 106: // Blue Prism
            return false;
        case 107: // SSC Blue Prism
            return false;
        default:
            return true;
    }
};

export default isMoneyEnabled;
